import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import EditRecipeCategoryLayer from "../../components/recipeCategory/EditRecipeCategoryLayer";


const EditRecipeCategoryPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Edit Recipe Category" />

        {/* AddUserLayer */}
        <EditRecipeCategoryLayer />


      </MasterLayout>
    </>
  );
};

export default EditRecipeCategoryPage;
